export default "__VITE_ASSET__f1454db3__"